<template>
  <v-container grid-list-lg>
    <v-layout wrap>
      <v-flex xs12 class='pa-3'>
         <v-card>
            <v-card-title class='headline font-weight-regular oem-color'>
              Helpful Downloads
            </v-card-title>
            <v-card-text>
              <a :href='downloadPath + "Setra Power Meter Data Sheet.pdf"' download='Setra Power Meter Data Sheet.pdf'>
                <img :src='pdf'>Setra Power Meter Data Sheet</a>
              <br />
              <a :href='downloadPath + "Setra Power Meter Quick Start Guide.pdf"' download='Setra Power Meter Quick Start Guide.pdf'>
                <img :src='pdf'>Setra Power Meter Quick Start Guide</a>
              <br />
              <a :href='downloadPath + "Setra Power Meter Installation and Operation Manual.pdf"' download='Setra Power Meter Installation and Operation Manual.pdf'>
                <img :src='pdf'>Setra Power Meter Installation and Operation Manual</a>
              <br />
              <br />
              <a :href='downloadPath + "Setra Power Meter BACnet Objects List.pdf"' download='Setra Power Meter BACnet Objects List.pdf'>
                <img :src='pdf'>BACnet Objects List</a>
              <br />
              <a :href='downloadPath + "Setra Power Meter Modbus Register List.pdf"' download='Setra Power Meter Modbus Register List.pdf'>
                <img :src='pdf'>Modbus Register List</a>
            </v-card-text>
         </v-card>
      </v-flex>
      <v-flex xs12 class='pa-3'>
         <v-card>
            <v-card-title class='headline font-weight-regular oem-color'>
              Contact
            </v-card-title>
            <v-card-text>
              <b>Setra Systems, Inc.</b>
              <br />
              159 Swanson Road
              <br />
              Boxborough, MA 01719
              <br />
              <br />
              Phone Support:
              <a href='tel:+1.800.257.3872'>+1.800.257.3872</a>
              <br />
              Web Support:
              <a href='https://www.setra.com/contact-us'>Contact us</a>
              <br />
              <a href='https://faq.setra.com/category/133-setra-systems-power-meter'>FAQ & Troubleshooting</a>
            </v-card-text>
         </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import * as ajax from '../ajax';

const pdfIcon = require('../assets/img/PDF_24.png');
// const placeholder = require('../assets/pdf-placeholder.pdf');

export default {
  name: 'Help',

  data() {
    return {
      storeState: this.$store.state,
      pdf: pdfIcon,
      downloadPath: `${ajax.baseWebUrl()}downloads/`,
    };
  },
};
</script>
